'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var object = {};

exports.__exports = object;
